/*global chrome*/
import React from "react";
import API, { base } from "../../api.js";
import Slider from "react-slick";
import User from "../../assets/images/user-circle.svg";
import { Link} from 'react-router-dom';

class VideoTuts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homePage: false,
      list: [],
    };
  }

  componentDidMount() {
    API({
      method: "GET",
      url: "testimonial/list",
      data: "json",
    })
      .then((data) => {
        this.setState({ list: data.data.response.data });
      })
      .catch(() => {
        this.setState({ lockSubmit: false });
      });
  }
  render() {
    var settings = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3.5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200, 
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767, 
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
    return (
      <section className="testimonials-section left-arrow-slider">   
              <h2 className="primary-heading text-center">
                {this.props.title ? this.props.title : "Testimonials"}               
              </h2>
              <div className="videosCntnt">
                <Slider {...settings}>
                  {this.state.list.map((item) => {
                    return (
                        <div className="testimonials-content" key={item.id}>
                            <p>{item.message}</p>
                            <div className='user-info'>
                                <div className="user-img-outer">
                                    <img className='user-img' src={User} alt="testimonial" />
                                </div>
                                <h3 className='user-name'>{item.name}</h3>
                            </div>
                        </div>
                    );
                  })}
                </Slider>
                <div className="d-flex justify-content-center">
                    <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                        REGISTER NOW
                        <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                    </span>
                    </Link>
                </div> 
              </div>       
      </section>
    );
  }
}

export default VideoTuts;
